module.exports = __webpack_public_path__ + "static/media/5.7ec65ab2.png";